// WebSocket
const IS_DEV = window.location.hostname === 'localhost';
const WS_PROTOCOL = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
const WS_URL = IS_DEV
    ? 'ws://localhost:8082'
    : `${WS_PROTOCOL}ws.${window.location.hostname}/`;

export let socket;

export function connect() {
    socket = new WebSocket(WS_URL);
    socket.addEventListener("open", () => {
        console.log("Socket: Connected")

        // Reload components
        const reconnectEventToRerender = new CustomEvent("ws-reconnect");
        window.dispatchEvent(reconnectEventToRerender);

        let timeNow = Date.now();
        let userID = String(Math.floor((timeNow / 1000000 - Math.floor(timeNow / 1000000)) * 1000000 * 7));
        let userIDLocalStorage = localStorage.getItem("userID");
        if (userIDLocalStorage) {
            userID = userIDLocalStorage;
        } else {
            localStorage.setItem("userID", userID);
        };

        const firstEndpoint = window.location.pathname.split('/').filter(Boolean)[0];
        const info = {
            type: "user-connected-information-request",
            data: {
                endpoint: firstEndpoint,
                userID: userID
            }
        };
        socket.send(JSON.stringify(info));
    });
    socket.addEventListener("message", (event) => {
        try {
            const parsedData = JSON.parse(event.data);
            const syntheticEvent = { data: parsedData };
            listeners.forEach(callback => callback(syntheticEvent));
        } catch (error) {
            console.error("Failed to parse incoming WebSocket message:", event.data);
        }
    });
    socket.addEventListener("error", (e) => { console.log("Socket: Error -> " + JSON.stringify(e)) });
    socket.addEventListener("close", () => {
        console.log("Socket: Closed (reconnection will be triggered in 1 seconds)")
        setTimeout(() => {
            connect();
        }, 1 * 1000);
    });
};

connect();

export const sendMessage = (data) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
        // Automatically stringify objects if you decide to send them later
        const payload = typeof data === 'string' ? data : JSON.stringify(data);
        socket.send(payload);
    } else {
        console.warn('Cannot send data. Socket connection is closed.');
    }
};

const listeners = [];

export const listenToMessages = (callback) => {
    listeners.push(callback);

    // Returns a function to remove the listener later if you want
    // Use inside return of useeffect to clear it from memory
    return () => {
        const index = listeners.indexOf(callback);
        if (index > -1) listeners.splice(index, 1);
    };
};

/*
Exportable values:

{listenToMessages((e) => {code, use e.data})}
{sendMessage(object)}

{listenToMessages, sendMessage}

*/